export const getCommandPaletteEvent = (eventName: string) => `command-palette-event-${eventName}`;
